
import dialogFlow from './libs/dialogFlow.js';
import stt from './libs/stt.js';
import player from './libs/player.js';
import googleAnalytics from './libs/googleAnalytics.js';


window.vidbaby = {
	$: {},
	player,
	config: {},
    initialized: false,
    libraryPath: "",
    dialogFlow: dialogFlow,
    stt: stt,
    isParked: true,
    mobile: {isMobile: false, type: 'none', orientation: 'none'},

    init :function(configPath, jQuery, libraryPath)
    {
        if (vidbaby.initialized == true) return(false);
        vidbaby.$ = jQuery;
        if(typeof libraryPath === 'string')
        	vidbaby.libraryPath = libraryPath;
        else
        	vidbaby.libraryPath = vidbaby.getLibPath();
        vidbaby.config = vidbaby.loadConfig(configPath);
        dialogFlow.init();
        stt.init();
        player.init();
        googleAnalytics.init();
        vidbaby.initialized = true;
		//vidbaby.start(playerContainerDomId);
        vidbaby.$(document).trigger("vidbaby-initialized");
	},

	/*start: function(playerContainerDomId) {
		player.build('#na-player_container');
		if (vidbaby.config.env.autoStart.loadToIdle) {
			vidbaby.baseUi.init(payload);
			vidbaby.baseUi.playerView.loadToIdle();
		}else if(vidbaby.config.env.autoStart.loadToVideo) {
			vidbaby.baseUi.init(payload);
			determineStart();
		}else{
			$(document).on('na-start.vidbaby', (event, payload) => {
				vidbaby.baseUi.init(payload);
				determineStart();
			});
		}
		function determineStart(){
			if (vidbaby.config.env.autoStart.initialVideo == "") {
				vidbaby.dialogFlow.ask('<<start>>', true);
			}else{
				playerView.loadVideo(vidbaby.config.env.autoStart.initialVideo);
			}
	       	vidbaby.$(document).trigger("wrapper:convoStarted");
		} 
	},*/

	loadConfig :function(configPath)
	{
		var config = vidbaby.util.readJSON(configPath + '/config.json');
		config.env = vidbaby.util.readJSON(configPath + '/' + window.location.hostname + '.json');

		return (config);
	},

/*
    //park and unpark seem like UI things, so maybe shouldn't be in here.
    
	park: function(state="hard") {
		console.log("Parked: " + state);
		vidbaby.$(document).trigger("park");
		vidbaby.isParked = true;
	},

	unPark: function() {
		vidbaby.$(document).trigger("unPark");
		vidbaby.isParked = false;
	},
*/
	getLibPath() {
		//performance.getEntries().slice(-1)[0].name
		var entries = performance.getEntries();
		for (var x = 0; x < entries.length; x++)
		{
			var entry = entries[x];
			var uri = entry.name;
			var fname = uri.slice(-10)
			if (fname == 'vidbaby.js'){
				var path = uri.slice(0, -11);
				return path;
			}


		};
		console.log("Error getting Lib path");
		return "Error getting Lib path";
	},

    util:
    {
	    readJSON: function(file) {
			return(vidbaby.util.readFile(file, "json"));
		},

		readScript: function(file) {
			return(vidbaby.util.readFile(file, "script"));
		},

		readFile: function(file, type = "text") {
			window.$ = window.$ || vidbaby.$;
			var returnData = null;
			$.ajax({
				async: false,
				datatype: type,
				url: file,
				success: function(data) {
					returnData = data;
				}//TODO add error handling
			});
			return(returnData);
		}//,

        // maybe also a UI thing???
		/*detectMobile: function() {
			var orientation = (window.screen.availWidth > window.screen.availHeight) ? "landscape" : "portrait";
			var isMobile = (window.screen.availWidth < 1024 || (window.screen.availHeight < 1024 && orientation != "landscape"));
			var mobileType = (!isMobile) ? "none" : ((window.screen.availWidth >= 600 && orientation == "portrait") || (window.screen.availHeight >= 600 && orientation == "landscape")) ? "tablet" : "phone";
			return {isMobile: isMobile, type: mobileType, orientation: orientation};
		}*/
	}

}
//vidbaby.init();


export default vidbaby;
